export const HUB_NAMES = {
  APP_NOTIFICATIONS: 'appNotifications',
  AUTOPILOT_TASKS: 'autopilotTasks',
} as const;

// The single negotiating service used for all SignalR hubs
export const NEGOTIATING_SERVICE = 'campaigns';
